import { Injectable } from "@angular/core";
import { ApiService } from "../api/api.service";
import { Guid } from "../../types/guid";
import { Observable } from "rxjs";
import {
  Schedule,
  SchedulePayload,
  ScheduleTopic,
} from "../../interfaces/course-schedule";

@Injectable({
  providedIn: "root",
})
export class CourseScheduleService {
  constructor(private readonly apiService: ApiService) {}

  getSchedule(CourseId: Guid, GroupId: Guid): Observable<Schedule> {
    return this.apiService.getRequest<Schedule>(
      `courses/${CourseId}/groups/${GroupId}/schedule`,
    );
  }

  createSchedule(
    CourseId: Guid,
    GroupId: Guid,
    schedule: SchedulePayload,
  ): Observable<Schedule> {
    return this.apiService.postRequest<Schedule>(
      `courses/${CourseId}/groups/${GroupId}/schedule/`,
      schedule,
    );
  }

  editSchedule(
    CourseId: Guid,
    GroupId: Guid,
    ScheduleId: Guid,
    schedule: SchedulePayload,
  ): Observable<Schedule> {
    return this.apiService.putRequest<Schedule>(
      `courses/${CourseId}/groups/${GroupId}/schedule/${ScheduleId}/`,
      schedule,
    );
  }

  editScheduleTopic(
    CourseId: Guid,
    GroupId: Guid,
    TopicId: Guid,
    schedule: SchedulePayload,
  ): Observable<ScheduleTopic> {
    return this.apiService.patchRequest<ScheduleTopic>(
      `courses/${CourseId}/groups/${GroupId}/schedule/topic/${TopicId}/`,
      schedule,
    );
  }
}
